import {
  all,
  any,
  compose,
  filter,
  map,
  pick,
  prop,
  reject,
  values
} from 'ramda'

import {
  getConditions,
  unternehmerGroß,
  unternehmerKlein,
  gründerGroß,
  gründerKlein,
  schnellkredit2020
} from './productConditions'

const ALL_PRODUCTS = [
  unternehmerGroß,
  unternehmerKlein,
  gründerGroß,
  gründerKlein,
  schnellkredit2020
]

const calculate = (attrs) => {
  const productConditions = getConditions(attrs)
  const numOfConditions = Object.keys(productConditions).length
  const attrNames = Object.keys(attrs)
  const numOfAttrs = attrNames.length

  const allConditionsAreMet = product => {
    if (numOfAttrs < numOfConditions) return false

    return compose(
      all(isValid => isValid),
      values,
      map(prop(product))
    )(productConditions)
  }

  const anyConditionFails = product => compose(
    any(isValid => !isValid),
    values,
    map(prop(product)),
    pick(attrNames) // Only look at filled values
  )(productConditions)

  return {
    matches: filter(allConditionsAreMet, ALL_PRODUCTS),
    potentialMatches: reject(anyConditionFails, ALL_PRODUCTS)
  }
}

export const getSubsidies = compose(
  calculate,
  map(prop('value'))
)
